export default __webpack_public_path__ + "static/media/10.676ee69e.jpg";